import { Card, CardBody } from '@/components/ui/Card';
import { Skeleton } from '@/components/ui/Skeleton';

/**
 * Standard first-paint placeholder for a lazily-loaded route.
 *
 * Shaped like the pages it stands in for — header, a row of KPI tiles, a
 * content block — so the layout doesn't jump when the real page arrives. The
 * alternative was a blank screen for the duration of the chunk fetch.
 */
export function PageSkeleton({ tiles = 4 }: { tiles?: number }) {
  return (
    <div aria-busy="true" aria-live="polite" className="space-y-4">
      <span className="sr-only">Loading page…</span>

      <div className="mb-4 space-y-2 sm:mb-6">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-4 w-96 max-w-full" />
      </div>

      {tiles > 0 ? (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {Array.from({ length: tiles }).map((_, i) => (
            <Card key={i}>
              <CardBody className="space-y-2">
                <Skeleton className="h-3 w-20" />
                <Skeleton className="h-7 w-28" />
                <Skeleton className="h-3 w-16" />
              </CardBody>
            </Card>
          ))}
        </div>
      ) : null}

      <Card>
        <CardBody className="space-y-2.5">
          {Array.from({ length: 8 }).map((_, i) => (
            <Skeleton key={i} className="h-6 w-full" />
          ))}
        </CardBody>
      </Card>
    </div>
  );
}
